import styled from 'styled-components';

export const ButtonContainerDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`;
